/** @format */

import React, { useEffect, useState } from 'react';
import { Row, Col, notification } from 'antd';
// import { LoadingOutlined, EnvironmentFilled } from '@ant-design/icons';
import './style.scss';
import { Service } from './service';
import { formatPrice } from '../../../../FormatPrice';
import { Enviroment } from '../../../../../../../../_config/constants/enviroment-v2.constant';
import Images from '../../../../../../Images';
import { ENV_COUNTRY, ENV_IMG_ROUTE } from '../../../../../Variables/Enviroment';
import CustomButton from '../../../../../../../../v2-components/Antd/Button';
import {default as magistralIcon} from '../../../../../../../../_config/images/formulamagistral.png'

const safeJSON = (key, fallback) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
};

const getKey = (item) => `cart-notification-${item?.objectID || item?.id || item?.id_pharol || 'default'}`;

const CartNotificationContent = ({ item, data }) => {
  const [modules, setModules] = useState([]);
  const [loadingModules, setLoadingModules] = useState(true);

  useEffect(() => {
    let mounted = true;
    new Service()
      .getModulesByTemplate('home', 'ecommerce', Enviroment.ROOT_PHARMACY)
      .then((res) => {
        if (!mounted) return;
        const payload = res?.data ?? res ?? [];
        setModules(Array.isArray(payload) ? payload : []);
        setLoadingModules(false);
      })
      .catch((err) => {
        console.error('Error cargando módulos:', err);
        if (mounted) setLoadingModules(false);
      });
    return () => { mounted = false; };
  }, []);

  const pharmacyIcon = modules.find((m) => m.location === 'icon-and-favicon');
  const iconUrl = pharmacyIcon?.image;

  const cart = safeJSON('cart', []);
  const amountItems = cart.reduce((sum, it) => sum + (Number(it?.quantity) || 0), 0);

  const getSubTotal = (it) => {
    const qty = Number(it?.quantity) || 0;
    if (it?.promotion_price !== it?.unit_price) {
      const is3x2 = it?.promotions?.rules?.mecanic === 'N x M' || it?.promotions?.rules?.mecanic === 'N x N' || (it?.promotions?.title && typeof it?.promotions?.title === 'string' && it?.promotions?.title?.toLowerCase()?.includes('3x2'));
      if (is3x2) {
        const reqQty = Number(it?.promotions?.rules?.quantity_per_requeriment) || 3;
        const bundleCount = Math.floor(qty / reqQty);
        const remainder = qty % reqQty;
        return (bundleCount * reqQty * Number(it?.promotion_price)) + (remainder * Number(it?.unit_price));
      }
      return Number(it?.promotion_price) * qty;
    }
    return Number(it?.sub_total) || (Number(it?.unit_price) * qty) || 0;
  };

  const getUnitPrice = (it) => {
    if (it?.promotion_price !== it?.unit_price) {
      const is3x2 = it?.promotions?.rules?.mecanic === 'N x M' || it?.promotions?.rules?.mecanic === 'N x N' || (it?.promotions?.title && typeof it?.promotions?.title === 'string' && it?.promotions?.title?.toLowerCase()?.includes('3x2'));
      if (is3x2) {
        const reqQty = Number(it?.promotions?.rules?.quantity_per_requeriment) || 3;
        const qty = Number(it?.quantity) || 0;
        if (qty > 0 && qty % reqQty === 0) {
          return Number(it?.promotion_price);
        }
        return Number(it?.unit_price);
      }
      return Number(it?.promotion_price);
    }
    return Number(it?.unit_price);
  };

  const totalPrice = cart.reduce((sum, it) => sum + getSubTotal(it), 0);

  const mapPharmacy = safeJSON('mapPharmacy', []);
  const nearest_local = Array.isArray(mapPharmacy) && mapPharmacy.length > 0 ? mapPharmacy[0]?.nearest_local : undefined;

  const handleBagLink = () => {
    notification.close(getKey(item));
    window.location.href = '/cart';
  };

  console.log('item en CartNotificationContent', item);

  return (
    <>
      <div className="ph-cart-notification-main-title-container">
        <h1 className="ph-cart-notification-main-title">¡Producto agregado a la Bolsa!</h1>
      </div>

      <Row className="ph-cart-notification-description-main-container">
        <Col span={4} className="ph-cart-notification-image-main-container">
          <Images
            classContent="ph-cart-notification-image-container"
            classImage="ph-cart-notification-image"
            webp={`${ENV_IMG_ROUTE}/products/${ENV_COUNTRY}/600x600/${item?.id_pharol}.webp`}
            default={ item?.quotation_type === 'magistral' ? magistralIcon : item?.image}
            alt={item?.editable_name}
            title={item?.editable_name}
          />
        </Col>

        <Col span={20}>
          <div className="ph-cart-notification-pharmacy">
            {!loadingModules && (
              <Images
                classContent="ph-cart-notification-pharmacy-image-container"
                classImage="ph-cart-notification-pharmacy-image"
                default={iconUrl || 'https://storage.googleapis.com/tirx-resources-develop/817f55db-81a6-46a4-affd-ac46d05deaa0.png'}
                alt={item?.pharmacy}
                title={item?.pharmacy}
              />
            )}
            <p className="ph-cart-notification-pharmacy-title">{nearest_local?.name_local}</p>
          </div>

          <h2 className="ph-cart-notification-title">{item?.name}</h2>

          <div className="ph-cart-notification-quantity-container">
            <p className="ph-cart-notification-quantity-title">Cantidad:</p>
            <p className="ph-cart-notification-quantity-description">{item?.quantity}</p>
          </div>

          <div className="ph-cart-notification-price-container">
            <p className="ph-cart-notification-price-title">Por unidad:</p>
            <p className="ph-cart-notification-price-description">{formatPrice(getUnitPrice(item))}</p>
          </div>

          {Number(item?.quantity) > 1 && (
            <div className="ph-cart-notification-price-container">
              <p className="ph-cart-notification-price-title">Sub-total:</p>
              <p className="ph-cart-notification-price-description">{formatPrice(getSubTotal(item))}</p>
            </div>
          )}

          {/* {data ? (
            data.response === true ? (
              <div>
                <h4 className="ph-cart-notification-response-positive-title" style={{ color: data.color_distance }}>
                  <EnvironmentFilled className="ph-cart-notification-response-positive-icon" /> {data.message} {data.distance_text}
                </h4>
              </div>
            ) : (
              <div className="ph-cart-notification-no-response-container">Error al consultar locales.</div>
            )
          ) : (
            <div className="ph-cart-notification-loading-container">
              <Spin indicator={<LoadingOutlined spin />} />
            </div>
          )} */}
        </Col>
      </Row>

      <hr className="ph-cart-notification-separator" />

      <Row>
        <Col span={12} className="ph-cart-notification-total-container">
          <Row>
            <p className="ph-cart-notification-total-title">Productos</p>
            <p className="ph-cart-notification-total-subtitle">({amountItems}):</p>
          </Row>
          <Row>
            <p className="ph-cart-notification-total-description">{formatPrice(totalPrice)}</p>
          </Row>
        </Col>
        <Col span={12} className="ph-cart-notification-total-button-main-container">
          <div onClick={handleBagLink}>
            <CustomButton className="button-primary">IR A LA BOLSA</CustomButton>
          </div>
        </Col>
      </Row>
    </>
  );
};

export const openCartNotification = ({ item, data, duration = 13, placement = 'topRight', key }) => {
  const notifKey = key ?? getKey(item);
  notification.open({
    key: notifKey,                 // mismo key => actualiza sin duplicar
    duration,
    placement,
    className: 'ph-cart-notification-main-container',
    description: <CartNotificationContent item={item} data={data} />,
  });
};

const CartNotification = (item, data, options = {}) => openCartNotification({ item, data, ...options });
export default CartNotification;
